import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, Typography, Box } from '@mui/material';
import { Logout as LogoutIcon, Person as PersonIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import UserAvatar from './UserAvatar'; // Import UserAvatar

interface LogoutButtonProps {
  isMobile: boolean; // New prop
}

const LogoutButton: React.FC<LogoutButtonProps> = ({ isMobile }) => {
  const { logout, user } = useAuth(); // Get user from AuthContext
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await logout();
    navigate('/login');
  };

  const handleProfileClick = () => {
    handleClose();
    navigate('/profile');
  };

  const avatarSize = isMobile ? 40 : 30; // Larger avatar on mobile
  const menuIconSize = isMobile ? 'medium' : 'small'; // Larger icons in menu on mobile

  return (
    <Box>
      <IconButton color="inherit" aria-label={t('account_menu', 'Menu account')} onClick={handleMenu}>
        <UserAvatar user={user} size={avatarSize} /> {/* Use UserAvatar */}
      </IconButton>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        <MenuItem onClick={handleProfileClick}>
            <PersonIcon sx={{ mr: 1 }} fontSize={menuIconSize} />
            <Typography variant="inherit">Profile</Typography>
        </MenuItem>
        <MenuItem onClick={handleLogout}>
            <LogoutIcon sx={{ mr: 1 }} fontSize={menuIconSize} />
            <Typography variant="inherit">Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default LogoutButton;
